import { MapLinkInfo } from './map-link-info.model';

export class MapTarget {
  id: string = null;
  relationInfos: Array<MapLinkInfo> = new Array<MapLinkInfo>();

  constructor(element: any) {
    if (element) {
      this.id = element.id;
      this.relationInfos = element.relationInfos ? element.relationInfos.map(x => new MapLinkInfo(x)) : new Array<MapLinkInfo>();
    }
  }
}
